import { v4 } from 'uuid';

export function setPlayerId(): string {
  const playerId = v4();
  localStorage.setItem('bingoPlayerId', playerId);
  return playerId;
}
